<template lang="pug">
.thermometer.container
  .row.xs-f-small.max-at-tweak
    div.max-width-tweak-upper
      .inner-wrap.xs-12.xs-text-left.sm-text-center.pb-200m.pt-200m
        h2.xs-12.kapra-neue.sm-f-xxlarge.bold.max-at-tweak.mb-50m {{title}}
        p {{description}}
        .bar-container.mt-150m.mb-200m
          .bar
            .bar-fill
          .bar-numbers.mt-50m
            span.xs-hide $0
            span.xs-hide $50
            span.xs-hide $100
            span $150
            span $200
            span $250
        .perk.mb-100m(v-if="show.limitless && limitless")
          span.bold {{limitlessName}}:&nbsp;
          span {{limitlessText}}
        .perk.mb-100m(v-if="show.premier && premier")
          span.bold {{premierName}}:&nbsp;
          span {{premierText}}
        .perk.mb-100m(v-if="show.plus && plus")
          span.bold {{plusName}}:&nbsp;
          span {{plusText}}
        .perk.mb-100m(v-if="show.pro && pro")
          span.bold {{proName}}:&nbsp;
          span {{proText}}
        .perk.mb-100m(v-if="show.proPlus && proPlus")
          span.bold {{proPlusName}}:&nbsp;
          span {{proPlusText}}
</template>

<script>
  import vueLoyaltySvc from '@services/vueLoyaltySvc';
  export default {
    name: 'LoyaltyStaticThermometer',
    props: {
      title: {
        type: String,
        default: '',
      },
      description: {
        type: String,
        default: '',
      },
      limitlessName: {
        type: String,
        default: 'Limitless',
      },
      premierName: {
        type: String,
        default: 'Premier',
      },
      plusName: {
        type: String,
        default: ':Limitless Plus',
      },
      proName: {
        type: String,
        default: 'Limitless Pro',
      },
      proPlusName: {
        type: String,
        default: 'Limitless Pro+',
      },
      limitlessTemplate: {
        type: String,
        default: 'Earn ${{earn}} towards your next purchase for every ${{spend}} Spent',
      },
      premierTemplate: {
        type: String,
        default: 'Earn ${{earn}} towards your next purchase for every ${{spend}} Spent',
      },
      plusTemplate: {
        type: String,
        default: 'Earn ${{earn}} towards your next purchase for every ${{spend}} Spent',
      },
      proTemplate: {
        type: String,
        default: 'Earn ${{earn}} towards your next purchase for every ${{spend}} Spent',
      },
      proPlusTemplate: {
        type: String,
        default: 'Earn ${{earn}} towards your next purchase for every ${{spend}} Spent',
      },
      show: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        limitless: null,
        premier: null,
        plus: null,
        pro: null,
        proPlus: null,
        fetched: false,
      };
    },
    computed: {
      proPlusText() {
        return this.replaceValues(this.proPlusTemplate, this.proPlus);
      },
      proText() {
        return this.replaceValues(this.proTemplate, this.pro);
      },
      premierText() {
        return this.replaceValues(this.premierTemplate, this.premier);
      },
      plusText() {
        return this.replaceValues(this.plusTemplate, this.plus);
      },
      limitlessText() {
        return this.replaceValues(this.limitlessTemplate, this.limitless);
      },
    },
    mounted() {
      vueLoyaltySvc
        .getByIds({ ids: [1, 2, 3, 4, 5] })
        .then(res => {
          this.limitless = res.data.limitless;
          this.premier = res.data.premier;
          this.plus = res.data.limitlessPlus;
          this.pro = res.data.limitlessPro;
          this.proPlus = res.data.limitlessProPlus;
          this.fetched = true;
        })
        .catch(() => {});
    },
    methods: {
      replaceValues(template, loyaltyData) {
        if (template && loyaltyData) {
          return template.replace('{{earn}}', loyaltyData.credit_reward).replace('{{spend}}', loyaltyData.spend_target);
        } else {
          return '';
        }
      },
    },
  };
</script>
<style scoped lang="stylus">
  .inner-wrap
    display grid
    grid-template-columns 10em 1fr 10em
    place-items center
    @media mq-mobile
      grid-template-columns 1.5em 1fr 1.5em

    & > *
      grid-column 2

    .bar-container
      width 100%
      display flex
      flex-direction column
      align-items center
      justify-content center
      @media mq-mobile
        grid-column 1/4

      .bar
        width 80%
        height 8px
        background-color ui-color-5
        border-radius 7px
        @media mq-mobile
            width 100%
            border-radius 0px

        .bar-fill
          display block
          width 80%
          height 100%
          background-color cta-color-1
          border-radius 7px
          position relative

          @media mq-mobile
            border-radius 0
            width 55%
          &:after
            content ''
            position absolute
            width 20px
            height 20px
            top -9px
            right -1px
            background-color white
            border 4px solid cta-color-1
            border-radius 50%
      .bar-numbers
        display flex
        justify-content space-between
        width 80%
</style>